<template>
  <div class="brand-container simple-search-table-container default-table">
    <div class="head">
      <div class="divide-title"><span></span>折扣设置</div>
      <el-button class="buttons" type="primary" size="mini" @click="handelCreate" v-if="userAuth.rebate_config_save">
        新增折扣
      </el-button>
    </div>
    <ape-table ref="apeTable" :data="tableData" :loading="loading" :paging-data="configPage"
               highlight-current-row border is-full-height>
      <el-table-column label="序号" type="index" width="50"/>
      <el-table-column prop="rebate" label="折扣" header-align="center" align="center" width="100"
                       show-overflow-tooltip/>
      <el-table-column prop="rule_explain" label="规则说明" header-align="center" align="center" min-width="200"
                       show-overflow-tooltip/>
      <el-table-column label="操作" header-align="center" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" icon="el-icon-edit"
                     v-if="userAuth.rebate_config_update" @click="handelUpdate(row)">修改
          </el-button>
          <el-button type="text" size="mini" icon="el-icon-delete"
                     v-if="userAuth.rebate_config_delete" @click="handelDelete(row)">删除
          </el-button>
        </template>
      </el-table-column>
    </ape-table>
    <el-dialog :title="dialogType==='CREATE'?'新增折扣':'编辑折扣'" :visible.sync="dialogStore" width="580px"
               center>
      <el-form label-width="80px" ref="elForm" :model="formStore" size="big" :rules="rules">
        <el-form-item prop="rebate" label="折扣">
          <el-input v-model="formStore.rebate" maxlength="40" clearable show-word-limit/>
          <el-tag @click="handleTag(item)" effect="plain" v-for="(item,index) in placeholderData" :key="index"
                  style="margin-right: 10px;cursor: pointer">{{
              item
            }}
          </el-tag>
        </el-form-item>

        <el-form-item prop="rule_explain" label="规则说明">
          <el-input clearable type="textarea" :rows="4" v-model="formStore.rule_explain" maxlength="120"
                    show-word-limit/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure" :disabled="loadingSubmit"
                   :loading="loadingSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable.vue";
import {delectDiscountsData, getDiscountsList, saveDiscountsData} from "@/api/discount";

const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 30,
  page: 1,
}

export default {
  name: "index",
  data() {
    return {
      tableData: [],
      loading: false,
      configPage: ConfigPage,
      formStore: {
        id: null,
        rebate: null,
        rule_explain: null
      },
      dialogType: 'CREATE',
      dialogStore: false,
      placeholderData: ['98折', '95折'],
      rules: {
        rebate: [
          {required: true, message: '请输入折扣', trigger: 'blur'},
        ],
        rule_explain: [
          {required: true, message: '请输入规则', trigger: 'blur'},
        ]
      },
      loadingSubmit: false
    }
  },
  components: {
    ApeTable
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handleTag(item) {
      this.$set(this.formStore, 'rebate', item)
    },
    handelCreate() {
      //新增
      this.formStore = {}
      this.dialogType = 'CREATE'
      this.dialogStore = true
    },
    handelUpdate(row) {
      this.formStore = row
      this.dialogType = 'EDIT'
      this.dialogStore = true
    },
    //删除
    // eslint-disable-next-line no-unused-vars
    async deleteRow(id) {
      await delectDiscountsData({id: id}).then(res => {
        return res.model
      })
      this.$nextTick(() => {
        this.getTableData()
      })
    },
    handelDelete(row) {
      this.$msgbox.confirm('此操作将永久删除该折扣设置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handelStoreSure() {
      let that = this

      this.$refs["elForm"].validate(valid => {
        if (valid) {
          this.loadingSubmit = true
          // saveDiscountsData
          // this.tableData.push(this.formStore)
          // this.dialogStore = false
          saveDiscountsData(this.formStore).then(res => {
            if (res.success) {
              that.showToast({
                title: '提交成功',
                h: that
              })
            }
            this.loadingSubmit = false
            this.dialogStore = false
            this.getTableData()
          })
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    async getTableData(isSearch = false) {
      const response = await getDiscountsList(this.getParams(isSearch))
      this.tableData = response.model.data || []
      this.configPage.total = response.model || 0
    },
    getParams(isSearch) {
      let params = this.$refs['apeTable'].getPagingInfo()
      params.page = isSearch ? 1 : params.current_page
      return params
    },
  }
}
</script>

<style lang="scss">
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .divide-title {
    font-size: 16px;
    font-weight: 600;
    color: #45474d;
    display: flex;
    align-items: center;
    float: left;

    span {
      width: 2px;
      height: 12px;
      background: #fe346e;
      margin-right: 8px;
    }
  }


}


</style>
